// src/pages/ContactPage.js

import React from 'react';
import ContactForm from '../components/ContactForm';
import usePageMeta from '../hooks/usePageMeta';
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK, EMAIL, ADDRESS } from '../config';

function ContactPage() {
  usePageMeta('צור קשר', 'צרו קשר עם דביר הנדסה ובניה: טלפון 053-2284404, וואטסאפ או השאירו פרטים בטופס ונחזור אליכם בהקדם.');

  return (
    <div id="main">
      <section className="post page-header">
        <h1>יצירת קשר</h1>
        <p>יש לכם פרויקט בקנה מידה קטן או גדול? נשמח לשמוע מכם, לייעץ ולתאם פגישת היכרות ללא התחייבות.</p>
      </section>

      <section className="post">
        <div className="contact-grid">
          <div className="contact-details-section">
            <h2>פרטי התקשרות</h2>
            <div className="contact-item">
              <i className="icon fa fa-phone"></i>
              <div>
                <h3>טלפון</h3>
                <p><a href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a></p>
              </div>
            </div>
            <div className="contact-item">
              <i className="icon fab fa-whatsapp"></i>
              <div>
                <h3>WhatsApp</h3>
                <p><a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">שלחו לנו הודעה</a></p>
              </div>
            </div>
            <div className="contact-item">
              <i className="icon fa fa-envelope"></i>
              <div>
                <h3>אימייל</h3>
                <p><a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
              </div>
            </div>
            <div className="contact-item">
              <i className="icon fa fa-map-marker-alt"></i>
              <div>
                <h3>כתובת</h3>
                <p>{ADDRESS}</p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>השאירו פרטים ונחזור אליכם</h2>
            <ContactForm isFullPage={true} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
